import { MessageCircle } from "lucide-react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SocialButtons = () => {
  const trackClick = async (network) => {
    try {
      await axios.post(`${API}/analytics/social-click`, {
        network,
        page: window.location.pathname,
      });
    } catch (error) {
      // Silent fail for analytics
      console.debug("Social click tracking failed:", error);
    }
  };

  return (
    <div className="fixed bottom-20 right-2 md:right-6 z-50 flex flex-col gap-1.5 md:gap-2">
      {/* Facebook Button */}
      <a
        href="https://www.facebook.com/share/1AsCcf34Bx/?mibextid=wwXIfr"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="facebook-button"
        onClick={() => trackClick("facebook")}
        className="flex items-center justify-center w-9 h-9 md:w-12 md:h-12 bg-[#1877F2] hover:bg-[#166FE5] text-white shadow-lg hover:shadow-xl transition-all duration-300 rounded-full"
        style={{ boxShadow: '0 4px 15px rgba(24, 119, 242, 0.4)' }}
      >
        <svg className="w-4 h-4 md:w-6 md:h-6" viewBox="0 0 24 24" fill="currentColor">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      </a>

      {/* TikTok Button */}
      <a
        href="https://www.tiktok.com/@fast.and.car.94"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="tiktok-button"
        onClick={() => trackClick("tiktok")}
        className="flex items-center justify-center w-9 h-9 md:w-12 md:h-12 bg-black hover:bg-zinc-800 text-white shadow-lg hover:shadow-xl transition-all duration-300 rounded-full border border-zinc-700"
        style={{ boxShadow: '0 4px 15px rgba(0, 0, 0, 0.4)' }}
      >
        <svg className="w-4 h-4 md:w-5 md:h-5" viewBox="0 0 24 24" fill="currentColor">
          <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
        </svg>
      </a>

      {/* Instagram Button */}
      <a
        href="https://www.instagram.com/fast.ncar"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="instagram-button"
        onClick={() => trackClick("instagram")}
        className="flex items-center justify-center w-9 h-9 md:w-12 md:h-12 text-white shadow-lg hover:shadow-xl transition-all duration-300 rounded-full"
        style={{ 
          background: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)',
          boxShadow: '0 4px 15px rgba(225, 48, 108, 0.4)' 
        }}
      >
        <svg className="w-4 h-4 md:w-6 md:h-6" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
        </svg>
      </a>

      {/* WhatsApp Button */}
      <a
        href="https://wa.me/33768013271"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-button"
        onClick={() => trackClick("whatsapp")}
        className="flex items-center justify-center w-9 h-9 md:w-12 md:h-12 bg-[#25D366] hover:bg-[#128C7E] text-white shadow-lg hover:shadow-xl transition-all duration-300 rounded-full relative"
        style={{ boxShadow: '0 4px 15px rgba(37, 211, 102, 0.4)' }}
      >
        <MessageCircle className="w-4 h-4 md:w-6 md:h-6 fill-white" />
        {/* Pulse animation */}
        <span className="absolute -top-0.5 -right-0.5 w-2 h-2 md:w-3 md:h-3">
          <span className="absolute inline-flex h-full w-full animate-ping bg-[#25D366] opacity-75 rounded-full"></span>
          <span className="relative inline-flex h-2 w-2 md:h-3 md:w-3 bg-[#25D366] rounded-full"></span>
        </span>
      </a>
    </div>
  );
};

export default SocialButtons;
